<template>
  <div>
    <v-layout row justify-end class="mt-2">
      <v-flex xs12>
        <InputSearch class="mb-3" :search="filter" @clickSearch="onSearch" :placeholder="'ค้นหา'" />
      </v-flex>
    </v-layout>

    <v-flex xs12>
      <div style="display: flex; align-items: center">
        <v-flex>
          <Typography h2 bold :label="$t('Category')" />
        </v-flex>
        <v-btn
          variant="outlined"
          icon
          :color="'#BECCDB'"
          style="border-radius: 50% !important"
          @click="addCategory = true"
        >
          <img :src="`/static/img/Add.png`" alt class="responsive-img" style="height: 14px" />
        </v-btn>
      </div>
    </v-flex>

    <!-- <v-layout row wrap dense class="ma-0">
      <v-flex xs6>
        <div class="headline primary--text">{{ $t('Category') }}</div>
      </v-flex>
      <v-flex xs6 style="display: flex; align-items: flex-end; justify-content: flex-end">
        <div class="text-xs-right form-control" style="display: flex; align-items: center">
          <div class="text-xs-center">
            <v-btn
              @click="addCategory = true"
              color="#152d53"
              small
              outline
              style="color: #152d53; text-transform: capitalize"
              class="px-4"
              ><i class="fas fa-plus mr-2"></i>Add Category</v-btn
            >
          </div>
        </div>
      </v-flex>
    </v-layout>
    <div style="display: flex; justify-content: flex-end">
      <div class="depainput form-control mb-3" style="position: relative; width: 40%">
        <input
          v-model="searchText"
          @keyup="searchByText(searchText)"
          style="padding-right: 47px !important"
          type="text"
        />
        <v-btn
          @click="searchByText(searchText)"
          :loading="loading"
          style="position: absolute; right: 0px; top: 0px"
          icon
          ><v-icon color="primary">search</v-icon></v-btn
        >
      </div>
    </div> -->
    <v-layout class="my-5" justify-center v-if="loading">
      <v-progress-circular
        :size="100"
        :width="10"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-layout>
    <div v-else>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="showData"
        :pagination.sync="pagination"
        hide-actions
        select-all
        item-key="name"
        class="fixTable"
      >
        <template v-slot:headers="props">
          <tr style="background-color: #152d53; color: white">
            <th
              style="background-color: #152d53; color: yellow; text-align: left"
              v-for="(header, k) in props.headers"
              :key="header.text + k"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr
            v-for="(item, kagent) in props.item.categories"
            :key="props.index + ' ' + kagent"
            class="py-3 depatable"
          >
            <td
              style="border-right: 1px solid #e3e3e3; vertical-align: baseline; width: 70px"
              v-if="kagent === 0"
              :rowspan="props.item.categories.length"
            >
              <Typography left h5 :label="item.categoryid || '-'" />
            </td>
            <td class="text-xs-left">
              <Typography left h5 :label="item.categoryname || '-'" />
            </td>
            <td
              style="border-right: 1px solid #e3e3e3; vertical-align: baseline"
              v-if="kagent === 0"
              :rowspan="props.item.categories.length"
            >
              <Typography left h5 :label="selectTypeByid(props.item.typeid) || '-'" />
            </td>
            <td class="text-xs-center" style="width: 70px">
              <!-- <v-btn @click="clickUpdate(props.item)" icon outline>
                <i :color="$vuetify.theme.primary" class="fas fa-pencil-alt"></i>
              </v-btn>
              <v-btn @click="clickDelete(props.item.categoryid)" icon outline>
                <v-icon color="primary">delete</v-icon>
              </v-btn> -->
              <TooltipTable
                :datas="props"
                @modalEdit="clickUpdate(item.categoryid, item.categoryname, props.item.typeid)"
                @Delete="deleteCategory(item.categoryid)"
                showDelete
              ></TooltipTable>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-if="addCategory"
      v-model="addCategory"
      :content-class="'overflow-y-visible'"
      persistent
      max-width="500"
    >
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="addCategory = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-layout class="mx-3 pb-3" column>
          <Typography class="mb-2" h2 bold label="เพิ่มหมวดหมู่" />
          <Typography h5 semiBold label="ชื่อหมวดหมู่*" />
          <div class="form-control px-1 pb-2" :class="{ 'has-error': errors.has('Category name') }">
            <input
              type="text"
              v-model="createCategory.name"
              placeholder="กรอกชื่อหมวดหมู่"
              class="form-control"
              maxlength="255"
              name="Category name"
              v-validate="'required'"
            />
            <p class="text-error" v-if="errors.has('Category name')">
              {{ errors.first('Category name') }}
            </p>
          </div>
          <Typography h5 semiBold label="ประเภทธุรกิจ*" />
          <div class="form-control px-1 pb-2" :class="{ 'has-error': errors.has('Type name') }">
            <multiselect
              v-model="createCategory.type"
              :options="typeList"
              selectLabel
              selectedLabel
              deselect-label
              placeholder="เลือกประเภทธุรกิจ"
              name="Type name"
              v-validate="'required'"
            >
              <span slot="caret" slot-scope="{ toggle }" class="arrow">
                <v-icon class="darkBlue" aria-hidden="false" size="24px">
                  mdi-chevron-down
                </v-icon>
              </span>
            </multiselect>
            <!-- <DropdownMenu
              v-model="createCategory.type"
              v-validate="'required'"
              :options="typeList"     
            >
              <div style="position: relative" class="form-control">
                <input
                  :value="createCategory.type"
                  placeholder="เลือกประเภทธุรกิจ"
                  type="text"
                  class="option-input rsu"
                  style="cursor: pointer"
                />
              </div>
            </DropdownMenu> -->
            <p class="text-error" v-if="errors.has('Type name')">{{ errors.first('Type name') }}</p>
          </div>
          <div style="display: flex; justify-content: center" class="mt-3">
            <Button :loading="loading" outline :label="$t('cancel')" @click="addCategory = false" />
            <Button :loading="loading" depressed :label="$t('Save')" @click="saveCategory" />
          </div>

          <!-- <v-layout row justify-center>
            <v-btn
              @click="saveCategory"
              color="#152d53"
              outline
              style="color: #152d53; text-transform: capitalize"
              class="px-4"
              >ตกลง</v-btn
            >
          </v-layout> -->
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="updateCategory"
      v-model="updateCategory"
      max-width="500"
      style="overflow-y: visible !important;"
    >
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="updateCategory = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-layout class="mx-3 pb-3" column>
          <Typography class="mb-2" h2 bold label="แก้ไขหมวดหมู่" />
          <Typography h5 semiBold label="ชื่อหมวดหมู่*" />
          <div class="form-control px-1 pb-2" :class="{ 'has-error': errors.has('Category name') }">
            <input
              type="text"
              v-model="updateData.name"
              placeholder="กรอกชื่อหมวดหมู่"
              class="form-control"
              maxlength="255"
              name="Category name"
              v-validate="'required'"
            />
            <p class="text-error" v-if="errors.has('Category name')">
              {{ errors.first('Category name') }}
            </p>
          </div>
          <Typography h5 semiBold label="ประเภทธุรกิจ*" />
          <div class="form-control px-1 pb-2" :class="{ 'has-error': errors.has('Type name') }">
            <DropdownMenu v-model="updateData.type" v-validate="'required'" :options="typeList">
              <div style="position: relative" class="form-control">
                <input
                  :value="updateData.type"
                  placeholder="เลือกประเภทธุรกิจ"
                  type="text"
                  class="option-input rsu"
                  style="cursor: pointer"
                />
              </div>
            </DropdownMenu>
            <!-- <multiselect
              v-model="updateData.type"
              :options="typeList"
              selectLabel
              selectedLabel
              deselect-label
              placeholder="type"
              name="Type name"
              v-validate="'required'"
            ></multiselect> -->
            <p class="text-error" v-if="errors.has('Type name')">{{ errors.first('Type name') }}</p>
          </div>

          <div style="display: flex; justify-content: center" class="mt-3">
            <Button
              :loading="loading"
              outline
              :label="$t('cancel')"
              @click="updateCategory = false"
            />
            <Button :loading="loading" depressed :label="$t('Save')" @click="fetchUpdate" />
          </div>

          <!-- <div class="headline primary--text text-xs-center mt-0">Update Category</div>
          <v-flex class="form-control pa-1">
            <label for>Category Name</label>
            <v-layout row>
              <input
                type="text"
                v-model="updateData.name"
                placeholder="Category name"
                class="form-control"
                maxlength="255"
              />
              <multiselect
                class="ml-3"
                v-model="updateData.type"
                :options="typeList"
                selectLabel
                selectedLabel
                deselect-label
                placeholder="type"
              ></multiselect>
            </v-layout>
          </v-flex>
          <v-layout row justify-center>
            <v-btn
              @click="fetchUpdate"
              color="#152d53"
              outline
              style="color: #152d53; text-transform: capitalize"
              class="px-4"
              >ตกลง</v-btn
            >
          </v-layout> -->
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="popDelete" max-width="500">
      <v-card class="p-3">
        <v-card-title class="text-h5 grey lighten-2">
          <h6>ต้องการจะลบใช่หรือไม่</h6>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteCategory"> ใช่ </v-btn>
          <v-btn color="danger" text @click="popDelete = false"> ยกเลิก </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <Paginations
      @clickPagination="changepage"
      @sortPage="sortPage"
      :pageCount="pageCount"
      :numberPage="numberPage"
      :page="page"
    />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import api from '@/api'
import InputSearch from '@/components/elements/InputSearch.vue'
import Typography from '@/components/elements/Typography.vue'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import Button from '@/components/elements/Button.vue'
import Paginations from '@/components/elements/Paginations.vue'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'

export default {
  components: {
    Multiselect,
    InputSearch,
    Typography,
    TooltipTable,
    Button,
    Paginations,
    DropdownMenu
  },
  data() {
    return {
      filter: {
        nameAll: ''
      },
      clickCreate: false,
      loading: true,
      searchText: '',
      addCategory: false,
      updateCategory: false,
      pagination: {
        descending: false,
        sortBy: 'categoryname',
        rowsPerPage: 999
      },
      createCategory: {
        name: '',
        type: ''
      },
      headers: [
        { text: 'ID', align: 'center', value: 'id' },
        { text: this.$t('Category'), align: 'center', value: 'Category' },
        { text: this.$t('Techhunt Type'), align: 'center', value: 'type' },
        { text: '', align: 'center', value: 'delete' }
      ],
      data: [],
      showData: [],
      type: [],
      typeList: [],
      updateData: {
        id: null,
        name: '',
        type: null
      },
      page: 1,
      pageTotal: 0,
      rowsPerPage: 12,
      numberPage: {
        page: undefined
      }
    }
  },
  computed: {
    pageCount() {
      if (this.pageTotal !== 0) {
        let count = Math.ceil(this.pageTotal / this.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.rowsPerPage - this.rowsPerPage : this.rowsPerPage
    }
  },
  async mounted() {
    await this.setupData()
    this.loading = false
  },
  methods: {
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      await this.setupData()
      this.loading = false
    },
    async sortPage(pages) {
      let count = Math.ceil(this.pageTotal / this.rowsPerPage)
      if (pages == '' || Number(pages <= 0) || pages > Number(count)) return
      if (pages) {
        this.page = parseInt(pages)
        this.loading = true
        await this.setupData()
        this.loading = false
      }
    },
    async onSearch() {
      this.loading = true
      this.page = parseInt(1)
      await this.setupData()
      this.loading = false
    },
    setupData() {
      this.getCategory()
      this.getType()
    },
    clickUpdate(categoryid, categoryname, typeid) {
      this.updateData.id = categoryid
      this.updateData.name = categoryname
      this.updateData.type = this.selectTypeByid(typeid)
      this.updateCategory = true
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    async deleteCategory(id) {
      this.$swal
        .fire({
          type: 'question',
          text: 'ยืนยันการลบ?',
          showCancelButton: true
        })
        .then(async result => {
          if (result.value) {
            let res = await api.deleteCategory(id)
            if (res == 204) {
              this.getCategory()
            }
          }
        })
    },
    async fetchUpdate() {
      var isValid = await this.$validator.validate()
      if (isValid && this.updateData.name && this.updateData.type && this.updateData.id) {
        let body = {
          categoryname: this.updateData.name,
          typeid: this.searchType(this.type, this.updateData.type)
        }
        let res = await api.updateCategory(this.updateData.id, body)
        if (res == 204) {
          this.$swal.fire({
            type: 'success',
            title: '<div class="headline primary--text bold7 fs-24">แก้ไขข้อมูลสำเร็จ</div>',
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
          })
          this.getCategory()
          this.updateData = {
            id: null,
            name: '',
            type: null
          }
          this.updateCategory = false
        }
      }
    },
    async saveCategory() {
      var isValid = await this.$validator.validate()
      if (isValid && this.createCategory.name && this.createCategory.type) {
        let obj = {
          categoryname: this.createCategory.name,
          typeid: this.searchType(this.type, this.createCategory.type)
        }
        let res = await api.createCategory(obj)
        if (res == 204) {
          this.createCategory.name = ''
          this.createCategory.type = ''
          this.addCategory = false
          this.$swal.fire({
            type: 'success',
            title: '<div class="headline primary--text bold7 fs-24">บันทึกข้อมูลสำเร็จ</div>',
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
          })
          this.getCategory()
        }
      } else {
        this.clickCreate = true
      }
    },
    async getCategory() {
      this.loading = true
      try {
        var params = {
          nameAll: this.filter.nameAll ? this.filter.nameAll : null,
          limit: this.limitCom,
          offset: this.offsetCom
        }
        this.data = await api.getCategory(params)

        this.showData = this.data.data
        this.pageTotal = this.data.total ? this.data.total : []
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },
    async getType() {
      try {
        this.type = await api.getType()
        this.typeList = []
        this.type.data.forEach(ele => {
          this.typeList.push(ele.typename)
        })
      } catch (error) {
        console.error(error)
      }
    },
    // searchByText(text) {
    //   if (text == '') {
    //     this.showData = this.data
    //     return
    //   }
    //   let output = []
    //   this.data.forEach((ele) => {
    //     if (
    //       ele.categoryname.toLowerCase().match(text.toLowerCase()) ||
    //       ele.typename.toLowerCase().match(text.toLowerCase())
    //     ) {
    //       output.push(ele)
    //     }
    //   })
    //   this.showData = output
    // },
    searchType(arr, text) {
      for (let i = 0; i < arr.data.length; i++) {
        if (arr.data[i].typename == text) {
          return arr.data[i].typeid
        }
      }
    },
    selectTypeByid(id) {
      for (let i = 0; i < this.type.data.length; i++) {
        if (this.type.data[i].typeid == id) {
          return this.type.data[i].typename
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fixTable table.v-table {
  thead {
    tr {
      th:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      th:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
  tbody {
    tr {
      td:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        background: #ffffff;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      td:last-child::after {
        content: '';
        border-left: 0;
      }
      td:not(:first-child)::after {
        content: '';
        position: absolute;
        border-left: 0px solid #d9d9d9 !important;
        height: 50%;
        left: 0;
        top: 25%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/techhuntMaster/Category.vue